import React from 'react';
import type { HrBlock } from '@/types/contentBlocks';

interface HrBlockProps {
  block: HrBlock;
  isDarkMode: boolean;
}

export const HrBlockRenderer: React.FC<HrBlockProps> = ({ block, isDarkMode }) => {
  return <hr className={`my-4 ${isDarkMode ? 'border-[#505050]' : 'border-border'}`} />;
};
